module.exports = __webpack_public_path__ + "static/nodata@2x.bdbaae2e.png";